import Http from "../../../../../core/http-axios-react/http/Http";
import { HttpBaseResponse, HttpData } from "../../../../../core/HttpResponse";
import { M_Category } from "../../../type/Produk.type";

export const getCategory = async ({
  page,
  keyword,
}: {
  page: number;
  keyword?: string;
}) => {
  const result = await Http.get<HttpBaseResponse<HttpData<M_Category[]>>>({
    url: "/product/category",
    params: {
      page,
      keyword,
    },
  });
  return result;
};

export const getCategoryDetail = async ({
  product_category_id,
}: {
  product_category_id?: string;
}) => {
  const result = await Http.get<HttpBaseResponse<M_Category>>({
    url: "/product/category/detail",
    params: {
      product_category_id,
    },
  });
  return result;
};

export const addCategory = async ({
  category_name,
}: {
  category_name: string;
}) => {
  const result = await Http.post({
    url: "/product/category/insert",
    data: {
      category_name,
    },
  });
  return result;
};

export const updateCategory = async ({
  product_category_id,
  category_name,
}: {
  product_category_id: string;
  category_name: string;
}) => {
  const result = await Http.post({
    url: "/product/category/update",
    data: {
      category_name,
      product_category_id,
    },
  });
  return result;
};

export const importCategory = async ({ file }: { file: File }) => {
  const results = await Http.post({
    url: "/product/category/import",
    data: {
      file,
    },
  });
  return results;
};
